import React from 'react'

import { Card, Flex, SimpleGrid, StatusBadge, Text } from '@driftt/dds'

import { OpportunityAttribution } from 'layouts/RevenueReport/components/OpportunityAttribution'
import { TypeFormats } from 'utils/format'

import { getOpportunityStageVariant } from '../Opportunities.utils'

import { TimelineSummaryCardProps } from './TimelineSummaryCard.types'

export const TimelineSummaryCard = ({
  title,
  type,
  totalArr,
  opportunityStage,
  createdDate,
  lastUpdateDate,
  isInfluenced,
  isSourced,
}: TimelineSummaryCardProps) => {
  return (
    <Card width="100%">
      <Card.Header>
        <Flex
          direction="row"
          gap={1}
          justifyContent="flex-start"
          alignItems="center"
        >
          <Card.Title variant="h3">{title}</Card.Title>
          <OpportunityAttribution
            isInfluenced={isInfluenced}
            isSourced={isSourced}
          />
        </Flex>
      </Card.Header>
      <Card.Content>
        <SimpleGrid columns={3} gap={2}>
          <Flex direction="column" alignItems="flex-start" gap="half">
            <Text variant="metadata">Type</Text>
            <Text variant="body">{type}</Text>
          </Flex>
          <Flex direction="column" alignItems="flex-start" gap="half">
            <Text variant="metadata">Total ARR</Text>
            <Text variant="body">
              {TypeFormats.CURRENCY_UNROUNDED(Number(totalArr))}
            </Text>
          </Flex>
          <Flex direction="column" alignItems="flex-start" gap="half">
            <Text variant="metadata">Status</Text>
            <StatusBadge variant={getOpportunityStageVariant(opportunityStage)}>
              {opportunityStage}
            </StatusBadge>
          </Flex>
          <Flex direction="column" alignItems="flex-start" gap="half">
            <Text variant="metadata">Created</Text>
            <Text variant="body"> {TypeFormats.DATE_SLASH(createdDate)}</Text>
          </Flex>
          <Flex direction="column" alignItems="flex-start" gap="half">
            <Text variant="metadata">Last update</Text>
            <Text variant="body">{TypeFormats.DATE_SLASH(lastUpdateDate)}</Text>
          </Flex>
        </SimpleGrid>
      </Card.Content>
    </Card>
  )
}
